export function getComponentDisplayName(Component) {
  var displayName = Component.displayName || Component.name || 'Component';
  if (displayName[0] === '_') {
    return displayName.substring(1);
  }
  return displayName;
}